import { useMemo } from "react";

import { useGetSdlJson } from "../../components/hooks";
import { IKeyStringAndValue } from "../types/Types";

//Special cases that uses values from diffrent keys in the same column
const useUpdateRowData = (listView: string) => {
  const { data } = useGetSdlJson(listView);

  const rowData =
    listView === "test_tabeller_solceller"
      ? data?.solceller
      : listView === "test_tabeller_varmesystem"
      ? data?.varmesystem
      : data?.cars;

  return useMemo(() => {
    if (rowData) {
      const updated = rowData.reduce(
        (acc: Array<IKeyStringAndValue>, cur: IKeyStringAndValue) => {
          const curCopy = { ...cur };
          if (curCopy.model_version) {
            curCopy.model_version = curCopy.annual_interval
              ? curCopy.model_version + " " + curCopy.annual_interval
              : curCopy.model_version;
          } else {
            curCopy.model_version = curCopy.annual_interval
              ? curCopy.make +
                " " +
                curCopy.model +
                " " +
                curCopy.annual_interval
              : curCopy.arsintervall
              ? curCopy.make + " " + curCopy.model + " " + curCopy.arsintervall
              : curCopy.make + " " + curCopy.model;
          }
          curCopy.mda_end = curCopy.mda_end ? curCopy.mda_end : "-";
          curCopy.euroncap = curCopy.euroncap_year
            ? curCopy.euroncap + "|" + curCopy.euroncap_year
            : curCopy.euroncap;
          const autobreakBike =
            // Special case for safe list since it now has it's own column for autobreak cyclist.
            // But we don't want to make this change for all lists since some has this incorporated in the same column.
            listView !== "test_tabeller_safe"
              ? parseInt(curCopy.autobreak_bike) || 0
              : 0;
          curCopy.autobreak_pedestrian =
            autobreakBike > 1
              ? curCopy.autobreak_pedestrian + "*"
              : curCopy.autobreak_pedestrian;
          curCopy.co2 = curCopy.co2_over_under
            ? curCopy.co2 + "|" + curCopy.co2_over_under
            : curCopy.co2;
          acc.push(curCopy);
          return acc;
        },
        []
      );

      return updated;
    } else return [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
};
export default useUpdateRowData;
